export const GUEST_ID = 'GUEST_ID';
export const GUEST_CART_ID = 'GUEST_CART_ID';
export const TOKEN = 'TOKEN';
export const ADMIN_TOKEN = 'ADMIN_TOKEN';
export const TEMP_TOKEN = 'TEMP_TOKEN';
export const REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE';
export const USER_ID = 'USER_ID';
export const EMOJI =
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const OTP_REGEX = /^\d{6}$/;
export const PHONE_REGEX = /^[6-9]\d{9}$/;
export const LANDLINE_REGEX = /^\+?\d{0,4}[- ]?\d{10}$|^\d{5}[- ]?\d{6}$/;
export const WEBSITE_REGEX =
  /^(https?:\/\/)?(www\.)?[a-z0-9-]+(\.[a-z]{2,})+(\/[a-z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?$/i;
export const PANNO_REGEX = /^[A-Z]{5}\d{4}[A-Z]$/i;
export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/i;
export const ACCOUNT_NUMBER_REGEX = /^\d{9,18}$/;
export const GSTNO_REGEX = /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/i;
export const AADHAR_REGEX = /^[2-9]\d{3}\d{4}\d{4}$/i;
export const NUM_REGEX = /^\d*$/im;
export const POSTALCODE_REGEX = /^(\d{4}|\d{6})$/;
export const NAME_REGEX = /^[a-zA-Z][a-zA-Z ]+[a-zA-Z]$/;
export const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-]).{8,}/;
export const SIGNUP_MOBILE = 'SIGNUP_MOBILE';
export const SIGNUP_EMAIL = 'SIGNUP_EMAIL';

export const ORDER_CLASS_MAP = {
  // 4,11   purple
  // 5,10   success
  // 6,9,12 danger
  // 7,8,13 info
  // 1,14   secondary
  1: 'badge badge-pill badge-soft-secondary',
  2: 'badge badge-pill badge-soft-warning',
  3: 'badge badge-pill badge-soft-primary',
  4: 'badge badge-pill badge-soft-purple',
  5: 'badge badge-pill badge-soft-success',
  6: 'badge badge-pill badge-soft-danger',
  7: 'badge badge-pill badge-soft-info',
  8: 'badge badge-pill badge-soft-info',
  9: 'badge badge-pill badge-soft-danger',
  10: 'badge badge-pill badge-soft-success',
  11: 'badge badge-pill badge-soft-purple',
  12: 'badge badge-pill badge-soft-danger',
  13: 'badge badge-pill badge-soft-info',
  14: 'badge badge-pill badge-soft-secondary',
};

export const LEVEL_LIST = [
  {
    id: 3,
    name: 'L6 Position',
    roleid: 3,
  },
  {
    id: 4,
    name: 'L5 Position',
    roleid: 4,
  },
  {
    id: 5,
    name: 'L4 Position',
    roleid: 5,
  },
  {
    id: 11,
    name: 'L3 Position',
    roleid: 11,
  },
  {
    id: 12,
    name: 'L2 Position',
    roleid: 12,
  },
  {
    id: 13,
    name: 'L1 Position',
    roleid: 13,
  },
];

export const MARKER_COLOR_IMAGE_OBJ: any = {
  0: {
    color: '#CC5500',
    image: 'blue_marker.svg',
    name: 'RetailingExample',
  },
  1: {
    color: '#74C0FC',
    image: 'blue_marker.svg',
    name: 'RetailingExample',
  },
  2: {
    color: '#63E6BE',
    image: 'green_marker.svg',
    name: 'RetailingExample',
  },
  3: {
    color: '#B197FC',
    image: 'purple_marker.svg',
    name: 'RetailingExample',
  },
  4: {
    color: ' #DA58D8',
    image: 'pink_marker.svg',
    name: 'RetailingExample',
  },
  5: {
    color: '#FB6060',
    image: 'red_marker.svg',
    name: 'RetailingExample',
  },
  6: {
    color: '#FACC15',
    image: 'yellow_marker.svg',
    name: 'RetailingExample',
  },
  8: {
    color: '#000000',
    image: 'black_marker.svg',
    name: 'RetailingExample',
  },
};

export const imageDefaultExtention: string = '.jpg,.png,.jpeg,.webp';

export enum tableColumnId {
  CheckBox = 0,
  Image = 1,
  EditAllowed = 2,
  AlignCenter = 3,
  Other = 4,
  Status = 5,
  CatSubCat = 6,
  AlignEnd = 7,
}

export enum CompanyPermissionId {
  SuperdistributorLogin = 1,
  DistributorLogin = 2,
  IncludeGst = 5,
  OwnerImgRequired = 8,
  InvoiceRequired = 11,
  isOrderNoReq = 12,
}

export enum apiMethodEnum {
  GET = 1,
  POST = 2,
  PUT = 3,
  DELETE = 4,
}

export const endpoint = {
  soDetailById: '/api/v1/B2B/admin/SalesOrderDetailsById',
  poDetailById: '/api/v1/B2B/admin/OrderDetailsById',
  invoiceList: '/api/v1/B2B/admin/InvoicesList',
  invoiceDetailById: '/api/v1/B2B/admin/InvoiceDetailById',
  invoiceListDdl: '/api/v1/B2B/admin/InvoiceListDdl',
  salesOrderPreview: '/api/v1/B2B/admin/SalesOrderPreview',
  productListByInvoiceId: '/api/v1/B2B/admin/InvoicesProductList',
  generateClaim: '/api/v1/B2B/admin/SchemeClaimAddUpdt',

  claimList: '/api/v1/B2B/admin/ClaimList',
  claimApprovalList: '/api/v1/B2B/admin/ClaimApprovalList',
  claimDetail: '/api/v1/B2B/admin/SchemeClaimDetails',
  claimWorkStatus: '/api/v1/B2B/admin/ClaimWorkStatus',
  deleteClaimRequest: '/api/v1/B2B/admin/DeleteClaimRequest',
  claimTypeDdl: '/api/v1/B2B/admin/ClaimTypeDdl',
  claimStatusList: '/api/v1/B2B/admin/ClaimStatusList',

  creditNoteList: '/api/v1/B2B/admin/MyCreditNoteList',
  adjustCNListByUserId: '/api/v1/B2B/admin/AdjustCNListByUserId',
  pendingClaimUserList: '/api/v1/B2B/admin/PendingClaimUserList',
  generateCreditNotes: '/api/v1/B2B/admin/GenerateCreditNotes',
  generateCreditNotesDirect: '/api/v1/B2B/admin/GenerateCreditNotesDirect',
  creditDebitNoteReason: '/api/v1/B2B/admin/CreditDebitNoteReason',
  claimCNStatusMaster: '/api/v1/B2B/admin/ClaimeCNStatusMaster',
  getGstSlabDdl: '/admin/GetGstSlabDdl',
  creditNotePreview: '/api/v1/B2B/admin/CreditNotePreview',
  creditNoteDetail: '/api/v1/B2B/admin/CreditNoteDetail',
  deleteCreditNote: '/api/v1/B2B/admin/DeleteCreditNote',

  exportCustomerMaster: '/api/v1/B2B/admin/ExportCustomerMaster',
  exportNoSaleReasonSummary: '/api/v1/B2B/admin/ExportNoSaleReasonSummary',
  exportProductAnalysis: '/api/v1/B2B/admin/ExportProductAnalysis',
  exportOutletWiseAnalysis: '/api/v1/B2B/admin/ExportOutletWiseAnalysis',
  exportItemInStockReport: '/api/v1/B2B/admin/ExportItemInStockReport',
  customerWisePSReport: '/api/v1/B2B/admin/CustomerWisePSReport',
  schemeAnalysisReport: '/api/v1/B2B/admin/SchemeAnalysisReport',
  exportOrderDumpMaster: '/api/v1/B2B/admin/ExportOrderDumpMaster',
  exportTaDaReport: '/api/v1/B2B/admin/ExportTaDaReport',
  exportClaimSummaryReport: '/api/v1/B2B/admin/ExportClaimSummaryReport',
  productivityReport: '/api/v1/B2B/admin/ExportEmployeeProductivityReport',

  allowanceTypeDdl: '/api/v1/Sales/Admin/AllowanceTypeDdl',
  transportModeDdl: '/api/v1/Sales/Admin/TransportModeDdl',
  expenseTypeDdl: '/api/v1/Sales/Admin/ExpenseTypeDdl',
  allowanceList: '/api/v1/Sales/Admin/AllowanceList',
  addUpdateAllowance: '/api/v1/Sales/Admin/AddUpdateAllowance',
  allowanceDetail: '/api/v1/Sales/Admin/AllowanceDetail',
  allowanceWorkStatus: '/api/v1/Sales/Admin/AllowanceWorkStatus',
  allowanceStatus: '/api/v1/Sales/Admin/AllowanceStatus',
};

export enum routingPermission {
  dashboard = 38,

  order = 9,
  superDistributorOrder = 16,
  distributionOrder = 10,
  dealerOrder = 11,
  userSalesOrder = 12,

  distributor = 17,
  retailer = 18,
  banner = 24,

  catalogue = 25,
  scheme = 43,

  gstSlabConfig = 64,
  dscntSlabConfig = 63,
  cartonConfig = 13,
  discount = 14,

  authRequest = 15,
  outletUpdationReq = 66,

  pendingGrn = 45,
  completedGrn = 46,

  myCreditNote = 79,
  customerCreditNote = 80,
  myDebitNote = 81,
  customerDebitNote = 82,

  nsm = 27,
  ansm = 28,
  rsm = 29,
  asm = 30,
  ase = 31,
  tsi = 32,
  employeeManagement = 26,

  position = 33,
  salesPerformance = 34,
  liveMap = 35,
  tourPlan = 65,
  myTaDa = 83,
  taDaApproval = 84,

  prodMaster = 60,
  catMater = 22,
  subCatMaster = 23,
  zoneMaster = 59,
  stateMaster = 19,
  cityMaster = 20,
  beatMaster = 21,
  expenseMaster = 85,
  transportMaster = 86,
  noSaleCatMaster = 61,
  noSaleSubCatMaster = 62,
  unitMaster = 89,

  attandenceReport = 36,
  dailyStatsReport = 37,
  customerMastrReport = 67,
  noSaleRsnReport = 68,
  productAnalysisReport = 69,
  outletWiseAnalysisReport = 70,
  itemInStockReport = 71,
  customerWisePsReport = 72,
  schemeAnalysisReport = 77,
  orderDumpReport = 78,
  claimReport = 87,
  taDaReport = 88,
  productivityReport = 90,
}

export const routeUrl = {
  poReceivedList: '/admin/b2b/purchase-order/po-received',
  poReceivedDetail: '/admin/b2b/purchase-order/po-received-detail',
  poReceivedEdit: '/admin/b2b/purchase-order/po-received-edit',

  poRaiseList: '/admin/b2b/purchase-order/po-raise',
  poRaiseAdd: '/admin/b2b/purchase-order/po-raise-create',
  poRaiseEdit: '/admin/b2b/purchase-order/po-raise-edit',
  poRaiseDetail: '/admin/b2b/purchase-order/po-raise-detail',

  pendingGrnList: '/admin/b2b/purchase-order/pending-grn',
  pendingGrnDetail: '/admin/b2b/purchase-order/pending-grn-detail',
  completedGrnList: '/admin/b2b/purchase-order/completed-grn',
  completedGrnDetail: '/admin/b2b/purchase-order/completed-grn-detail',

  userSalesOrderList: '/admin/b2b/sale-order/user-sale-order',
  salesOrderList: '/admin/b2b/sale-order/sale-order',
  salesOrderDetail: '/admin/b2b/sale-order/sale-order-detail',

  salesInvoiceList: '/admin/b2b/sale-order/invoice',
  salesInvoiceDetail: '/admin/b2b/sale-order/invoice-detail',

  distributorOrderList: '/admin/b2b/sub-order/distributor-order',
  distributorOrderDetail: '/admin/b2b/sub-order/distributor-order-detail',
  dealerOrderList: '/admin/b2b/sub-order/dealer-order',
  dealerOrderDetail: '/admin/b2b/sub-order/dealer-order-detail',

  superDistributorList: '/admin/b2b/user/super-distributor',
  superDistributorDetail:
    '/admin/b2b/user/super-distributor/super-distributor-details',
  superDistributorEdit:
    '/admin/b2b/user/super-distributor/edit-super-distributor',
  superDistributorAdd:
    '/admin/b2b/user/super-distributor/add-super-distributor',

  distributorList: '/admin/b2b/user/distributor',
  distributorDetail: '/admin/b2b/user/distributor/distributor-details',
  distributorEdit: '/admin/b2b/user/distributor/edit-distributor',
  distributorAdd: '/admin/b2b/user/distributor/add-distributor',

  retailerList: '/admin/b2b/user/retailer',
  retailerDetail: '/admin/b2b/user/retailer/retailer-details',
  retailerEdit: '/admin/b2b/user/retailer/edit-retailer',
  retailerAdd: '/admin/b2b/user/retailer/add-retailer',

  claimList: '/admin/b2b/claim/my-claim',
  myClaimDetail: '/admin/b2b/claim/my-claim-detail',
  claimAprroval: '/admin/b2b/claim/claim-approval',
  claimAprrovalEdit: '/admin/b2b/claim/claim-approval-edit',
  claimApprovalDetail: '/admin/b2b/claim/claim-approval-detail',
  claimGenerate: '/admin/b2b/claim/my-claim-create',

  myCreditNoteList: '/admin/b2b/cn-dn/my-credit-note',
  myCreditNoteDetail: '/admin/b2b/cn-dn/my-credit-note-detail',
  customerCreditNoteList: '/admin/b2b/cn-dn/customer-credit-note',
  customerCreditNoteDetail: '/admin/b2b/cn-dn/customer-credit-note-detail',
  creditNoteAdd: '/admin/b2b/cn-dn/customer-credit-note-create',

  myDebitNoteList: '/admin/b2b/cn-dn/my-debit-note',
  myDebitNoteDetail: '/admin/b2b/cn-dn/my-debit-note-detail',
  customerDebitNoteList: '/admin/b2b/cn-dn/customer-debit-note',
  customerDebitNoteDetail: '/admin/b2b/cn-dn/customer-debit-note-detail',
  debitNoteAdd: '/admin/b2b/cn-dn/customer-debit-note-create',

  reportRequest: '/admin/b2b/report-log',

  taDaList: '/admin/b2b/sales/ta-da/my-ta-da',
  taDaDetail: '/admin/b2b/sales/ta-da/my-ta-da-detail',
  taDaUpdate: '/admin/b2b/sales/ta-da/my-ta-da-update',
  taDaAdd: '/admin/b2b/sales/ta-da/my-ta-da-add',
  taDaApprovalList: '/admin/b2b/sales/ta-da/ta-da-approval',
  taDaApprovalDetail: '/admin/b2b/sales/ta-da/ta-da-approval-detail',
  taDaApprovalUpdate: '/admin/b2b/sales/ta-da/ta-da-approval-update',
};
